import { useAtom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';
import type { ScriptDto } from '../script/script.dto';
import { GenerationType } from '../video-model/model-spec';

const fissionAtom = atomWithStorage<ScriptDto>(
  'script_fission_page_data_v4',
  {
    id: null!,
    aspect_ratio: '9:16',
    duration: 5,
    file_list: [],
    product_name: '',
    product_description: '',
    segments: [],
    fission: null!,
    product_image_filename: '',
    size: '720x480',
    generation_type: GenerationType.Frame,
    prompt: '',
    source: void 0,
    generate_audio: true,
  },
  void 0,
  { getOnInit: true },
);

export function useFissionPageData() {
  return useAtom(fissionAtom);
}
